import { BaseArticleOperation } from './base-article-operation';
import { ArticleInfoVO } from '@project/model/vo/project.vo';
import { ArticleVO } from '@article/model/vo/article.vo';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { ArticleContainerFactory } from '@3d-scene/model3d/article-container.factory';
import { ProjectModel } from '@project/model/project.model';
import { ContainerService } from '@3d-scene/model3d/container.service';

export class BaseDynamicArticleOperation extends BaseArticleOperation {
  private _dynamicArticle: ArticleVO;

  constructor(
    articleContainer: ArticleContainer,
    projectModel: ProjectModel,
    articleContainerFactory: ArticleContainerFactory,
    containerService: ContainerService,
    private _articleInfo: ArticleInfoVO,
  ) {
    super(
      projectModel,
      articleContainerFactory,
      containerService,
      articleContainer
    );
    this._dynamicArticle = articleContainer.article;
  }

  public get articleInfo(): ArticleInfoVO {
    return this._articleInfo;
  }

  public get dynamicArticle(): ArticleVO {
    return this._dynamicArticle;
  }
}
